import { useEffect } from 'react';
import { JumbotronDatas } from '../../Components/Public/Functions/JumbotronDatas.js';
import { CarrouselDatas } from '../../Components/Public/Carrousel/CarrouselDatas.js';
import { FilterOrigins } from "../../Components/Public/Filters/FilterOrigins.js";
import { FilterCategory } from "../../Components/Public/Filters/FilterCategory.js";
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
/* document */
import { Navigation } from '../../Components/Public/Document/Navigation.js';
import { Header } from '../../Components/Public/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { Carrousel } from '../../Components/Public/Carrousel/Carrousel.js';
import { Jumbotron } from '../../Components/Public/Document/Jumbotron.js';
import { WaltDisney } from '../../Components/Public/Document/WaltDisney.js';
import { BlockLogoParksAndUnivers } from '../../Components/Public/Logos/BlockLogoParksAndUnivers.js';
import { BlockCollection } from '../../Components/Public/Blocks/BlockCollection.js';
import { AnimCarrousel } from '../../Components/Public/Functions/AnimCarrousel.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';

export const Home = (props) => {
    const { navParks, body, att, cha, arc, ren } = props;
    const ori = FilterOrigins('home', att);
    const cat = FilterCategory('home', att);
    const jumbotron = JumbotronDatas(navParks, att, ren, arc);
    const carrouselDatas = CarrouselDatas('home', att);
    useEffect(() => {
        AnimCarrousel();
        ScrollTop();
    }, []);
    const body_walt_disney = body[0] ? body[0] : [];
    return (
        <div className="home">
            <Navigation navParks={navParks} />
            <Header />
            <Carrousel label="home" datas={carrouselDatas} total={att.length} />
            <Jumbotron datas={jumbotron} />
            <WaltDisney body={body_walt_disney} />
            <section className="infos">
                <div className="block-parks">
                    {navParks.map((item, i) => {
                        return (
                            <div className="bloc-infos" key={i}>
                                <BlockLogoParksAndUnivers label="park" item={item} />
                                <BlockCollection label="home" datas={item.univers} att={att} />
                            </div>
                        )
                    })}
                </div>
                <div className="block-collections">
                    <div className="bloc-infos">
                        <BlockCollection label="categories" datas={cat} att={att} />
                    </div>
                    <div className="bloc-infos">
                        <BlockCollection label="origins" datas={ori} att={att} cha={cha} />
                    </div>
                </div>
            </section>
            <BackTop />
            <Footer />
        </div>
    )
}
